import GolfCourse from "./images/icons/golf-course.svg"
import City from "./images/icons/round-location-city.svg"
import Coins from "./images/icons/two-coins.svg"

export default{
    GolfCourse,
    City,
    Coins 
}